import { makeStyles, Typography } from "@material-ui/core";
import { FiberManualRecord } from "@material-ui/icons";
import moment from "moment";
import React from "react";

const useStyles = makeStyles(
  _ => ({
    dot: {
      fontSize: "0.75rem",
      marginRight: "5px"
    },
    time: {
      color: "#494E56",
      fontSize: "1rem",
      fontWeight: 600
    },
    timeContainer: {
      marginRight: "20px",
      width: "150px"
    }
  }),
  { name: "TimeContainer" }
);

interface TimeContainerProps {
  dateTimeStamp: string;
  eventStatus: string;
  eventStatusClass: string;
  showDot?: boolean;
}

const TimeContainer: React.FC<TimeContainerProps> = props => {
  const {
    dateTimeStamp,
    eventStatus,
    eventStatusClass,
    showDot = false
  } = props;
  const classes = useStyles(props);

  const formatTimeValue = moment
    .utc(dateTimeStamp)
    .local()
    .format("hh:mm:ssA");

  return (
    <div className={classes.timeContainer}>
      <Typography className={classes.time}>{formatTimeValue}</Typography>
      <Typography className={eventStatusClass}>
        {showDot && <FiberManualRecord className={classes.dot} />}
        {eventStatus}
      </Typography>
    </div>
  );
};

export default TimeContainer;
